import { render, staticRenderFns } from "./StaticDirectory.vue?vue&type=template&id=0d34aa55"
import script from "./StaticDirectory.vue?vue&type=script&lang=js"
export * from "./StaticDirectory.vue?vue&type=script&lang=js"
import style0 from "./StaticDirectory.vue?vue&type=style&index=0&id=0d34aa55&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports